//LOADING
export const TOGGLE_LOADING = 'TOGGLE_LOADING'

//-----------------------------------------------------------------------------------------//

//ERROR
export const UNAUTHORIZED_DEAL_ROOM = 'UNAUTHORIZED_DEAL_ROOM'

//-----------------------------------------------------------------------------------------//

// CREATE Deal Room Template
export const CREATE_TEMPLATE = 'CREATE_TEMPLATE'

// CREATED Deal Room Template ID
export const CREATED_TEMPLATE_ID = 'CREATED_TEMPLATE_ID'

// Deal Room Category List
export const FETCH_DEAL_ROOM_CATEGORY_LIST = 'FETCH_DEAL_ROOM_CATEGORY_LIST'

// Deal Room Template List
export const FETCH_DEAL_ROOM_TEMPLATE_LIST = 'FETCH_DEAL_ROOM_TEMPLATE_LIST'

// Deal Room Content List
export const FETCH_DEAL_ROOM_CONTENT_LIST = 'FETCH_DEAL_ROOM_CONTENT_LIST'

// Deal Room Template Details
export const FETCH_TEMPLATE_DETAILS = 'FETCH_TEMPLATE_DETAILS'

// Deal Room Template Introduction
export const FETCH_TEMPLATE_INTRODUCTION = 'FETCH_TEMPLATE_INTRODUCTION'

// Deal Room Template Section
export const FETCH_TEMPLATE_SECTION = 'FETCH_TEMPLATE_SECTION'

// Deal Room Section Asset List
export const FETCH_SECTION_ASSET_LIST = 'FETCH_SECTION_ASSET_LIST'

// Deal Room Section Asset Selected
export const SECTION_ASSET_SELECTED = 'SECTION_ASSET_SELECTED'

// Deal Room Template Setup
export const FETCH_TEMPLATE_SETUP = 'FETCH_TEMPLATE_SETUP'

// Deal Room Section Asset IgnoreIDs
export const SET_IGNORE_IDS = 'SET_IGNORE_IDS'

// CREATED Deal Room Template ID
export const CREATED_DEAL_ID = 'CREATED_DEAL_ID'

// Deal Room Template Publish Status
export const PUBLISH_STATUS = 'PUBLISH_STATUS'

//Get deal setup data 
export const FETCH_DEAL_SETUP = 'FETCH_DEAL_SETUP'

//Fetch access/Client list
export const FETCH_DEAL_ACCESS_LIST = 'FETCH_DEAL_ACCESS_LIST'

//Fetch buyers/contacts list
export const FETCH_DEAL_BUYERS_LIST = 'FETCH_DEAL_BUYERS_LIST'

//Fetch sellers/Users list
export const FETCH_DEAL_SELLERS_LIST = 'FETCH_DEAL_SELLERS_LIST'

//Deal room container sidebar active option
export const DEAL_ROOM_CONTAINER_ACTIVE_OPTION = 'DEAL_ROOM_CONTAINER_ACTIVE_OPTION'

//Deal room introduction
export const FETCH_DEAL_INTRODUCTION = 'FETCH_DEAL_INTRODUCTION'

//get deal details
export const FETCH_DEAL_DETAILS = 'FETCH_DEAL_DETAILS'

//get deal sections
export const FETCH_DEAL_SECTION = 'FETCH_DEAL_SECTION';

//Quick Filters
export const QUICK_FILTERS = "QUICK_FILTERS";

//get deal section asset list
export const FETCH_DEAL_SECTION_ASSET_LIST = 'FETCH_DEAL_SECTION_ASSET_LIST'

//Filter Search Key
export const SEARCH_KEY = "SEARCH_KEY"

//Filter Category Type
export const CATEGORY_TYPE = "CATEGORY_TYPE"

//Filter Status Type
export const STATUS_TYPE = "STATUS_TYPE"

//Filter Sort Type
export const SORT_TYPE = "SORT_TYPE"

//go live deal
export const GO_LIVE_STATUS = 'GO_LIVE_STATUS'

//get timeline history
export const GET_TIMELINE_LIST = 'GET_TIMELINE_LIST'

//get timeline recap list
export const GET_TIMELINE_RECAP_LIST = 'GET_TIMELINE_RECAP_LIST'

//get DR selected contacts
export const GET_DEALROOM_CONTACTS_LIST = 'GET_DEALROOM_CONTACTS_LIST'

//store the sendmail to contacts status
export const SEND_MAIL_TO_DEALROOM_CONTACTS_STATUS = 'SEND_MAIL_TO_DEALROOM_CONTACTS_STATUS'

//scheduled meetings list
export const SCHEDULED_MEETINGS_LIST = 'SCHEDULED_MEETINGS_LIST'

//store zoom link for meeting
export const GET_ZOOM_MEETING_LINK = 'GET_ZOOM_MEETING_LINK'

//get milestones list
export const GET_MILESTONES_LIST = 'GET_MILESTONES_LIST'

//set Zoom Code
export const SET_ZOOM_CODE = 'SET_ZOOM_CODE';

//set Zoom Code
export const SET_ZOOM_DETAILS = 'SET_ZOOM_DETAILS';

//get DEALROOM Comments
export const FETCH_DEALROOM_COMMENTS = 'FETCH_DEALROOM_COMMENTS';

//set DEALROOM Comments
export const SET_DEALROOM_COMMENTS = 'SET_DEALROOM_COMMENTS';

//set PDF PAGE ID
export const SET_PDF_PAGE_ID = 'SET_PDF_PAGE_ID';

//get milestone client documents list
export const GET_MILESTONE_CLIENT_DOCUMENT_LIST = 'GET_MILESTONE_CLIENT_DOCUMENT_LIST';

//get frontend milestones list
export const GET_MILESTONES_LIST_FRONTEND = 'GET_MILESTONES_LIST_FRONTEND';

//Delete DEALROOM Comments
export const DELETE_DEALROOM_COMMENTS = 'DELETE_DEALROOM_COMMENTS';

//Edit DEALROOM Comments
export const EDIT_DEALROOM_COMMENTS = 'EDIT_DEALROOM_COMMENTS';

//Edit Section Title Status
export const EDIT_SECTION_TITLE_STATUS = 'EDIT_SECTION_TITLE_STATUS';

//Set Left Nav Asset ID
export const NAV_ASSET_ID = 'NAV_ASSET_ID';
